import { render, staticRenderFns } from "./TransactionRuleDia.vue?vue&type=template&id=3104f86c&scoped=true"
import script from "./TransactionRuleDia.vue?vue&type=script&lang=js"
export * from "./TransactionRuleDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104f86c",
  null
  
)

export default component.exports